import React from "react";
import Credentials from "../components/Credentials";
import PageHero from "../components/PageHero";

function CredentialsPage() {
  return (
    <>
      <PageHero
        title="Our Credentials"
        crumb="Credentials"
        subtitle="Recognized by industry leaders for excellence in civil construction"
      />
      <Credentials />
    </>
  );
}

export default CredentialsPage;
